import type { CityConfig } from "../hawaii-city/types";

export const kailuaKonaConfig: CityConfig = {
  city: "Kailua-Kona",
  state: "Hawaii",
  stateAbbr: "HI",
  slug: "kailua-kona",
  route: "/kailua-kona",
  title: "Emergency & Expedited Passport Services in Kailua-Kona, HI — Fast Processing | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Kailua-Kona, HI. Fast passport renewal and urgent passport help for Big Island West Hawaii travelers and resort visitors. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Kailua-Kona, HI",
  heroSubtitle: "Kailua-Kona and West Hawaii travelers — get your passport fast without traveling to Hilo or Honolulu. Start online, ship overnight, and we handle the rest. As fast as 24 hours.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20Kailua-Kona%20Hawaii%20coastline%20at%20golden%20hour%2C%20Alii%20Drive%20waterfront%20with%20palm%20trees%2C%20calm%20turquoise%20Pacific%20Ocean%2C%20distant%20volcanic%20landscape%2C%20warm%20sunset%20lighting%2C%20professional%20travel%20photography%2C%20vibrant%20warm%20colors%20with%20deep%20blue%20ocean%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=kailuakona-hero-01&orientation=landscape",
  heroImageAlt: "Kailua-Kona Hawaii coastline at sunset with turquoise ocean and palm trees",
  geoPosition: "19.6400;-155.9969",
  geoPlacename: "Kailua-Kona, Hawaii",
  regionalAgency: {
    name: "Honolulu Passport Agency",
    address: "300 Ala Moana Blvd, Room 1-224, Honolulu, HI 96850",
    distance: "Inter-island flight to Honolulu — about 200 miles",
  },
  nearbyCitiesZips: [
    { name: "Kailua-Kona", zips: "96740" },
    { name: "Kealakekua", zips: "96750" },
    { name: "Captain Cook", zips: "96704" },
    { name: "Kainaliu", zips: "96740" },
    { name: "Holualoa", zips: "96725" },
    { name: "Waimea", zips: "96743" },
    { name: " Waikoloa", zips: "96738" },
    { name: "Kawaihae", zips: "96743" },
    { name: "Hilo", zips: "96720" },
    { name: "Honolulu", zips: "96815" },
    { name: "Kahului", zips: "96732" },
    { name: "Keauhou", zips: "96739" },
    { name: "Kohala", zips: "96755" },
    { name: "Hawi", zips: "96719" },
    { name: "Kalaoa", zips: "96740" },
    { name: "Honokaa", zips: "96727" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from your Kailua-Kona home or resort in minutes." },
    { icon: "ri-truck-line", title: "Ship Your Documents", desc: "Use overnight shipping from Kailua-Kona to send your documents directly to us." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is reviewed before submission to reduce errors and delays." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots — no public appointment needed for Big Island residents." },
  ],
  testimonials: [
    {
      name: "Robert C.",
      location: "Kailua-Kona, HI",
      rating: 5,
      text: "I live in Kailua-Kona and my passport expired the week before a business trip to Tokyo. Fast Passport Center had it processed and shipped back to me in under a week. The shipping from Kona was seamless.",
      service: "Passport Renewal",
    },
    {
      name: "Jennifer M.",
      location: "Waikoloa, HI",
      rating: 5,
      text: "We were visiting Waikoloa for a wedding and realized my husband's passport was missing. FPC guided us through the replacement process from the Big Island and had a new passport before our return flight.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Thomas K.",
      location: "Kealakekua, HI",
      rating: 5,
      text: "Emergency trip to Australia for a family matter. I'm in Kealakekua near Kona and FPC handled everything remotely. The passport arrived in 6 days. I honestly didn't think it was possible from the Big Island.",
      service: "Expedited Passport",
    },
  ],
  facilities: [
    {
      id: "kailua-kona-usps",
      name: "Kailua-Kona Post Office",
      type: "USPS Passport Acceptance",
      address: "74-5577 Kaiwi St",
      city: "Kailua-Kona",
      state: "HI",
      zip: "96740",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Downtown Kailua-Kona",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Appointment required. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "kealakekua-usps",
      name: "Kealakekua Post Office",
      type: "USPS Passport Acceptance",
      address: "82-6130 Mamalahoa Hwy",
      city: "Kealakekua",
      state: "HI",
      zip: "96750",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "South Kona — about 12 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "South Kona option. Confirm appointment and photo availability.",
      icon: "ri-mail-line",
    },
    {
      id: "waimea-usps",
      name: "Waimea Post Office",
      type: "USPS Passport Acceptance",
      address: "67-1197 Mamalahoa Hwy",
      city: "Waimea",
      state: "HI",
      zip: "96743",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Upcountry — about 40 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Upcountry option for North Kohala and Waimea residents.",
      icon: "ri-mail-line",
    },
    {
      id: "hilo-usps-kona",
      name: "Hilo Post Office",
      type: "USPS Passport Acceptance",
      address: "1548 Kamehameha Ave",
      city: "Hilo",
      state: "HI",
      zip: "96720",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "East Hawaii — about 80 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "East Hawaii option for Big Island residents. Long drive from Kona.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get a passport in Kailua-Kona, HI?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours. Standard processing through a Kailua-Kona post office can take 2–6 months. For West Hawaii residents, our courier service is the fastest option without flying to Honolulu.",
    },
    {
      q: "Do I need to fly to Honolulu for a passport?",
      a: "No. Most Kailua-Kona and West Hawaii travelers start online and ship documents via overnight courier. The Kailua-Kona Post Office can serve as an acceptance facility if needed, but you don't need to visit the Honolulu agency.",
    },
    {
      q: "Where is the closest passport acceptance facility to Kailua-Kona?",
      a: "The Kailua-Kona Post Office at 74-5577 Kaiwi St accepts passport applications by appointment. Kealakekua Post Office is also an option for South Kona residents. Waimea Post Office serves Upcountry and North Kohala.",
    },
    {
      q: "What if I'm a tourist in Kona and need a passport emergency?",
      a: "We frequently help tourists and vacationers in Kailua-Kona, Waikoloa, and the Kona Coast who discover passport issues while traveling. We can ship to your resort or hotel address and coordinate return shipping so you don't miss your flight.",
    },
    {
      q: "Can I get an expedited passport if I've never had one before?",
      a: "Yes, but first-time applicants require an in-person acceptance clerk visit. The Kailua-Kona Post Office is the most convenient option for West Hawaii residents. We guide you through exactly what to bring.",
    },
    {
      q: "How does shipping from Kailua-Kona work?",
      a: "You can ship overnight using FedEx or UPS from Kailua-Kona. Most West Hawaii residents use the FedEx location near Kona Commons or the UPS Store on Palani Road.",
    },
    {
      q: "Is Fast Passport Center an official government agency?",
      a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We work within the official passport system to provide expedited processing.",
    },
    {
      q: "What if I need a child passport in Kailua-Kona?",
      a: "Child passports (for minors 15 and under) require parental participation and an in-person acceptance step — both parents typically must consent. We provide clear instructions for Kailua-Kona and Kealakekua families.",
    },
    {
      q: "Can I get a passport if mine is lost or stolen?",
      a: "Yes. Lost or stolen passport replacements often require additional forms (including Form DS-64). We guide Kailua-Kona residents through the exact process, including the acceptance clerk visit and expedited submission.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Kailua-Kona", address: "75-5595 Palani Rd, Kailua-Kona, HI 96740", hours: "Daily 7 AM – 11 PM" },
    { name: "Walgreens — Waikoloa", address: "68-1845 Waikoloa Rd, Waikoloa, HI 96738", hours: "Daily 7 AM – 11 PM" },
    { name: "CVS Pharmacy — Kailua-Kona", address: "75-1027 Henry St, Kailua-Kona, HI 96740", hours: "Daily 7 AM – 10 PM" },
    { name: "The UPS Store — Kailua-Kona", address: "74-5588 Palani Rd, Kailua-Kona, HI 96740", hours: "Call for hours" },
    { name: "Walmart — Kailua-Kona", address: "75-1015 Henry St, Kailua-Kona, HI 96740", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Kona DMV — Kailua-Kona Satellite City Hall",
      address: "74-5565 Luhia St, Kailua-Kona, HI 96740",
      hours: "Mon–Fri, 7:45 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, state IDs. Appointment recommended.",
      featured: true,
    },
    {
      name: "Waimea DMV — Waimea Satellite City Hall",
      address: "67-5189 Kamamalu St, Waimea, HI 96743",
      hours: "Mon–Fri, 7:45 AM – 4:00 PM",
      note: "Upcountry option. Appointment recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "KOA",
      name: "Kona International Airport",
      distance: "Primary airport — West Hawaii",
      address: "73-200 Kupipi St, Kailua-Kona, HI 96740",
      note: "Major international airport for West Hawaii with direct flights to mainland U.S., Japan, and inter-island connections.",
      flightUrl: "https://www.hawaii.gov/koa/",
      flightLabel: "KOA Airport Website",
      featured: true,
    },
    {
      code: "ITO",
      name: "Hilo International Airport",
      distance: "About 80 miles east — East Hawaii",
      address: "2450 Kekuanaoa St, Hilo, HI 96720",
      note: "East Hawaii airport option. Inter-island connections to Honolulu and mainland.",
      flightUrl: "https://www.hawaii.gov/ito/",
      flightLabel: "ITO Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Flying in 24–72 hours? Our emergency courier service is designed for urgent, last-minute travel from Kailua-Kona and West Hawaii.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already have a U.S. passport? We help Kailua-Kona travelers renew fast and avoid delays — no agency visit required for most renewals.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants typically require an in-person acceptance clerk visit. We guide Kailua-Kona residents through every step.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements often require additional forms. We guide you through exactly what's needed to avoid costly mistakes.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors (15 and under) require parental participation and an in-person acceptance step. We provide clear instructions for Kailua-Kona families.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports for Kailua-Kona residents.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport & Damaged",
      description: "Need a second passport for frequent travel, or replacing a damaged one? We handle both efficiently.",
      bullets: ["Frequent traveler solutions", "Damaged passport replacement", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Kailua-Kona travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for Kailua-Kona residents with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance for Kailua-Kona residents with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for Kailua-Kona residents with lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Kailua-Kona, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service for Kailua-Kona residents after marriage, divorce, or legal name changes." },
    { name: "Second Passport & Damaged", description: "Second passport issuance for frequent Kailua-Kona travelers and damaged passport replacement." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Too Long to Apply", description: "Government processing times change constantly. Many Kailua-Kona travelers assume 6–8 weeks is safe, only to find out it's now 3–4 months. Apply as soon as you book travel." },
    { icon: "ri-camera-off-line", title: "Wrong Passport Photo", description: "Photos from drugstores and photo booths often get rejected for lighting, background, or expression issues. We provide exact specs so you get it right the first time." },
    { icon: "ri-file-damage-line", title: "Incomplete Forms", description: "One missing signature or wrong date and your application gets sent back. Our checklist catches errors before submission, saving you weeks of delay." },
    { icon: "ri-pen-nib-line", title: "Wrong Proof of Citizenship", description: "Not all birth certificates are accepted. Some require a long-form version. We tell you exactly which documents you need based on your situation." },
    { icon: "ri-calendar-close-line", title: "Missing Travel Proof for Emergency", description: "Regional agencies require proof of urgent travel. Without it, you're turned away. We help you prepare the right documentation before you need it." },
    { icon: "ri-map-pin-time-line", title: "Not Checking Name Consistency", description: "Your passport name must match your driver's license and ticket exactly. Middle names, suffixes, and hyphenated names cause more rejections than you'd think." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option from Kailua-Kona." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you don't have to fly to Honolulu." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up." },
  ],
  processingOptions: [
    { speed: "2–9", unit: "Business Days", label: "Fast Passport Center", tag: "Most Popular", tagColor: "bg-[#F6C344] text-[#1A365D]", features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"], highlight: true },
    { speed: "3–5", unit: "Weeks", label: "Fast Passport Center", tag: "Standard Expedited", tagColor: "bg-[#1A365D]/10 text-[#1A365D]", features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"], highlight: false, smartSaver: true },
    { speed: "1–2", unit: "Months", label: "Self-Service (Post Office)", tag: "Slowest", tagColor: "bg-gray-100 text-gray-400", features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"], highlight: false, muted: true },
    { speed: "24", unit: "Hours*", label: "Regional Agency Processing", tag: "Emergency Only", tagColor: "bg-gray-100 text-gray-500", features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"], highlight: false, emergency: true },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — limited availability, often weeks out", fpc: "No appointment needed to start", fpcGood: true },
    { feature: "In-Person Visit", agency: "Required — fly to Honolulu", fpc: "Most travelers ship documents overnight from Kailua-Kona", fpcGood: true },
    { feature: "Processing Speed", agency: "Urgent travel only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options", fpcGood: true },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review to reduce delays", fpcGood: true },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission availability", fpcGood: true },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable", fpc: "Predictable processing based on option selected", fpcGood: true },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only", fpc: "Most U.S. citizens with required documents", fpcGood: true },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Hilo", route: "/hilo" },
    { name: "Honolulu", route: "/honolulu" },
    { name: "Kahului", route: "/kahului" },
    { name: "Kailua", route: "/kailua" },
    { name: "Pearl City", route: "/pearl-city" },
    { name: "Kihei", route: "/kihei" },
  ],
  fpcOfficeAddress: "300 Ala Moana Blvd, Room 1-224, Honolulu, HI 96850",
  fpcOfficeNote: "After signing up online, choose what works best for you: courier pickup from your Kailua-Kona home, ship with our prepaid label from any UPS/FedEx location on Palani Road, or schedule a drop-off. Most West Hawaii clients ship overnight.",
  fpcOfficeDistance: "Serving Kailua-Kona and all of West Hawaii remotely",
  serviceAreaIntro: "Whether you are in Kailua-Kona, Kealakekua, Waikoloa, or anywhere on the Big Island's Kona Coast, Fast Passport Center makes expedited passport processing simple — no flights to Honolulu, no agency lines.",
  nearbyCitiesIntro: "Anywhere on the Big Island's West side — start online, ship overnight from Kailua-Kona, and we handle the rest.",
  comparisonIntro: "",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Kailua-Kona as simple as possible.",
  mistakesIntro: "These mistakes cause the most delays and rejections for Kailua-Kona travelers. Fast Passport Center reviews your documents before submission to catch these issues.",
  testimonialsIntro: "Real reviews from real travelers across Kailua-Kona, Kealakekua, and Waikoloa who trusted Fast Passport Center with their expedited passports.",
  faqIntro: "Everything Kailua-Kona and West Hawaii travelers ask us most often about expedited passport services.",
  resourcesIntro: "",
  localTravelThemes: [],
  landmarks: [],
  island: "Big Island",
  islandNickname: "Hawaii Island",
  landmarkCards: [
    {
      name: "Kona Coast",
      description: "World-famous for big game fishing, manta ray night dives, and Ironman World Championship, the Kona Coast draws international competitors and adventure travelers who all need valid passports.",
      imageUrl: "https://readdy.ai/api/search-image?query=Kona%20Coast%20Hawaii%20Big%20Island%20at%20sunset%2C%20dramatic%20lava%20coastline%20with%20turquoise%20ocean%2C%20colorful%20sunset%20sky%2C%20palm%20trees%20and%20tropical%20vegetation%2C%20professional%20travel%20photography%2C%20warm%20orange%20and%20gold%20colors%2C%20no%20readable%20text%20or%20signs&width=600&height=400&seq=kona-coast&orientation=landscape",
    },
    {
      name: "Place of Refuge (Pu'uhonua o Honaunau)",
      description: "This UNESCO National Historical Park preserves sacred Hawaiian royal grounds and is one of the most culturally significant sites in the Pacific. International visitors are drawn here year-round.",
      imageUrl: "https://readdy.ai/api/search-image?query=Puuhonua%20o%20Honaunau%20Place%20of%20Refuge%20Hawaii%20Big%20Island%2C%20ancient%20Hawaiian%20royal%20grounds%20with%20wooden%20tiki%20statues%2C%20palm%20trees%20along%20lava%20coastline%2C%20clear%20tropical%20water%2C%20bright%20sunny%20day%2C%20professional%20travel%20photography%2C%20no%20readable%20text%20or%20signs&width=600&height=400&seq=kona-place-of-refuge&orientation=landscape",
    },
    {
      name: "Hualalai Volcano",
      description: "The volcano that defines Kailua-Kona's landscape, Hualalai last erupted in 1801. Its slopes are home to luxury resorts and exclusive estates — and many international travelers.",
      imageUrl: "https://readdy.ai/api/search-image?query=Hualalai%20volcano%20Kona%20Hawaii%2C%20volcanic%20mountain%20with%20lush%20green%20slopes%20and%20coffee%20farms%2C%20tropical%20blue%20sky%2C%20distant%20ocean%20view%2C%20warm%20afternoon%20light%2C%20professional%20landscape%20photography%2C%20no%20readable%20text%20or%20signs&width=600&height=400&seq=kona-hualalai&orientation=landscape",
    },
  ],
  travelTips: [
    { icon: "ri-flight-takeoff-line", title: "KOA Has International Flights", description: "Kona International Airport (KOA) has direct flights to Japan, Canada, and mainland U.S. Many West Hawaii residents fly international from Kona — ensure passport validity before booking." },
    { icon: "ri-trophy-line", title: "Ironman World Championship", description: "The annual Ironman race draws thousands of international athletes to Kona every October. Athletes and spectators coming from abroad all need valid passports — we help with urgent renewals." },
    { icon: "ri-ship-line", title: "Cruise Ship Port", description: "Kailua Pier in downtown Kona is a popular Pacific cruise port. Passengers on international cruises must carry valid passports. Renew before booking cruise itineraries." },
    { icon: "ri-truck-line", title: "Ship from Palani Road", description: "FedEx and UPS on Palani Road and at Kona Commons offer overnight shipping. Documents shipped before 6pm arrive at our processing center the next morning." },
    { icon: "ri-global-line", title: "Japan & Pacific Travel", description: "Kona's significant Japanese-American community and tourist connections to Japan create year-round passport demand. Tokyo direct flights from KOA make proper passport maintenance essential." },
    { icon: "ri-map-pin-line", title: "No Passport Agency on Big Island", description: "The closest regional passport agency is in Honolulu — an inter-island flight away. Fast Passport Center saves you the trip — ship from Kona, we handle the rest." },
  ],
  statePageRoute: "/states/hawaii",
  statePageName: "Hawaii",
  dmvWebsite: "https://www.hawaii.gov/dot/highways/mvm",
  dmvLabel: "Hawaii DMV — Official Website",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (HI DOH)", url: "https://health.hawaii.gov/vitalrecords/", desc: "Hawaii Department of Health — Office of Health Status Monitoring for birth, death, marriage, and divorce certificates statewide" },
    { label: "Marriage Certificates (HI DOH)", url: "https://health.hawaii.gov/vitalrecords/marriage-certificates/", desc: "Certified copies of Hawaii marriage certificates from the Department of Health Vital Records Office" },
    { label: "Divorce Decrees (HI Family Court)", url: "https://www.courts.state.hi.us/self-help/court-forms/court-forms-family-court", desc: "Hawaii State Judiciary Family Court — divorce decree records by circuit" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Hawaii birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
};